import module from '../module';

module.directive('loadingIndicator', ['$', function ($) {
    return {
        replace: false,
        scope: {
            isLoading: "=loadingIndicator"
        },
        link: function ($scope, element) {
            $(element).prepend('<div class="loader"><div class="spinner"></div></div>');

            $scope.$watch('isLoading', function () {
                if ($scope.isLoading) {
                    $(element).addClass('panel-loading');
                } else {
                    $(element).removeClass('panel-loading');
                }
            }, true);
        }
    };
}]);


// WEBPACK FOOTER //
// ./src/modules/shared/directives/LoadingIndicatorDirective.js